export const DEVICE_STATUS_INACTIVE = 1;
export const DEVICE_STATUS_ACTIVE = 5;

export const PROTOCOL_MQTT_V1 = 1;
export const PROTOCOL_MQTT_V2 = 2;
